<template>
    <div>
        <component
            :is="footerComponent"
            v-if="preFooter?.canonicalUid && preFooterContent"
            :pre-footer="preFooterContent"
        />
    </div>
</template>

<script setup>
    import { PreFooterQuery } from '~/queries/sections/PreFooter'

    const { entry, digistormSettings } = storeToRefs(useSiteStore())

    const preFooter = computed(() => {
        return first(entry.value?.preFooter)
    })

    const data = ref(null)

    const preFooterContent = computed(() => {
        return get(data.value, 'ds_PreFooterEntries.0', {})
    })

    const footerComponent = defineAsyncComponent(() =>
        import(`./${ digistormSettings.value.preFooterType }/pre-footer.async.vue`)
    )

    onMounted(() => {
        nextTick(() => {
            useLazyAsyncQuery({
                query: PreFooterQuery,
                variables: {
                    canonicalUid: preFooter.value?.canonicalUid,
                },
                key: `pre-footer-${preFooter.value?.canonicalUid}`,
                cache: true,
            })
                .then((response) => {
                    data.value = toValue(get(response, 'data'))
                })
        })
    })

</script>

<style lang="scss" scoped>

</style>
